import reducer from "./reducer";
import selectors from "./selectors";

export default { selectors, reducer };
